<template>
  <div class="card content-text">
    <div
      :class="[
        'card-name-wrap',
        card.isStarted || card.isFinished ? 'filled' : ''
      ]"
    >
      <span
        class="card-name"
        v-html="card.name"
      />
    </div>
    <div
      v-if="isInfiniteBoost || card.boost || card.isFinished"
      class="card-boost-wrap"
    >
      <AppIcon
        v-if="card.isFinished"
        name="check_icon"
      />
      <div
        v-else-if="isInfiniteBoost"
        class="infinite-symbol"
      />
      <span
        v-else
        class="card-boost font-rubik"
      >
        {{ card.boost }}
      </span>
    </div>
    <span class="comment font-sedgwick-ave">
      {{ card.comment }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ContentSectionStableCoinExplanationStageCard',
  props: {
    card: {
      type: Object,
      default: {},
    },
    isInfiniteBoost: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  position: relative;

  .card-name-wrap {
    width: 87px;
    height: 87px;
    display: flex;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    border: 1px solid $yellow-100;
    color: $yellow-100;

    &.filled {
      background-color: $yellow-100;
      color: black
    }

    .card-name {
      font-size: 14px;
      line-height: 18px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .card-boost-wrap {
    top: -18px;
    width: 42px;
    height: 42px;
    right: -18px;
    display: flex;
    position: absolute;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background-color: $black;
    border: 1px solid $yellow-100;

    .card-boost {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      color: $yellow-100;
      text-transform: uppercase;
    }

    .infinite-symbol {
      width: 30px;
      height: 18px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('@/assets/images/content_section_stable_coin_explanation_infinite_symbol.png');
    }
  }

  .comment {
    top: -12px;
    left: -8px;
    font-size: 16px;
    line-height: 24px;
    color: $yellow-100;
    position: absolute;
    transform: translate(-50%, -50%) rotate(-33.47deg);
  }
}
</style>
